import axiosInstance from "./AxiosInstance";

export function createEmployeeApi(data){
    return axiosInstance.post('api/employees',data)
}

export function updateEmployeeApi(id,data){
    return axiosInstance.patch(`api/employees/${id}`,data)
}

export function getAllEmployeeListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`api/employees?${fparam}`)
}
export function getEmployeeDetailstApi(id){
    return axiosInstance.get(`api/employees/${id}`)
}
export function deleteEmployeeApi(id){
    return axiosInstance.delete(`api/employees/${id}`)
}